import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { MaterialModule } from './material.module';
import {BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {AuthImports} from './auth/auth-import';

import { WelcomeComponent } from './welcome/welcome.component';
import {AppRoutingModule } from './app-router';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './navigation/header/header.component';
import { SidebarListComponent } from './navigation/sidebar-list/sidebar-list.component';

import  {AuthService } from './auth/auth.services';
import { Exercises } from './traning/traning.services';
import {AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from "angularfire2/firestore";
import { environment} from '../environments/environment';
import { uiService} from  './shared/ui-services';
import {StoreModule } from  '@ngrx/store';
import {reducer} from  './app.reducer';
@NgModule({
  declarations: [
    AppComponent,
   WelcomeComponent,
    HeaderComponent,
    SidebarListComponent
  ],
  imports: [
           BrowserModule,
           MaterialModule,
           BrowserAnimationsModule,
           AppRoutingModule,
           FormsModule,
           AngularFireModule.initializeApp(environment.firebase),
           AngularFirestoreModule,
           AuthImports,
           StoreModule.forRoot(reducer)
  ],
  providers: [AuthService,Exercises,uiService],
  bootstrap: [AppComponent],
  entryComponents:[]
})
export class AppModule { }
